import Keycloak from "keycloak-js";
import environment from "./environments/Environment";
const keycloak = new Keycloak({
  url: environment.API_KEYCLOAK,
  realm: environment.API_KEYCLOAK_PATH,
  clientId: "whitefact-admin",
});

export default keycloak;